module.exports = __webpack_public_path__ + "img/cypress.92176d6e.jpg";